<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle" style="margin-top: 10px; margin-bottom: 5px">
            <el-breadcrumb-item :to="{ path: '/rolemanagement' }">角色列表</el-breadcrumb-item>
            <el-breadcrumb-item>{{ role_name }}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.object_type">
                <vDropdown
                    model_key="object_type"
                    model_name="请选择对象"
                    select_value="value"
                    request_uri="dropdownRoleRows"
                    :model_value_default="queryParams['object_type']"
                    @onDropChange="onDropChange"
                    ref="object_type_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="is_limit"
                    model_name="是否限制"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['is_limit']"
                    @onDropChange="onDropChange"
                    ref="is_limit_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            &nbsp;<el-button size="small" @click="batchSave" :loading="save_loading">批量保存</el-button>
            <div class="main_header_btns">
                <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="role_row"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['is_limit'])">
                                <el-checkbox v-model="scope.row[item.prop]"></el-checkbox>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="pagination">
                <el-pagination
                    v-show="false"
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[2000]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array } from '../../../../js/common';
import draggableList from '../../../common/Drawer.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'roleRowComponent',
    data() {
        return {
            draggable: {
                data_name: 'role_row'
            },
            save_loading: false,
            loading: true,
            role_name: '',
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            productDropData: [],
            formData: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
        this.role_name = this.$route.query.role_name || '';
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        //跳转详情
        toDetail(row, prop) {},
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 2000,
                is_export: 0,
                role_rid: this.$route.query.id,
                object_type: '',
                is_limit: ''
            };
            this.saveQueryParams();
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            localStorage.setItem('role_row_params', JSON.stringify(this.queryParams));
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            var queryParams = JSON.parse(localStorage.getItem('role_row_params'));
            if (queryParams) {
                this.queryParams = queryParams;
                this.queryParams.role_rid = this.$route.query.id;
            } else {
                this.initQueryParams();
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('role_row', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).role_row;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'roleRowLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        // 批量保存
        batchSave() {
            this.$confirm('确认批量保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    if (!this.tableData || this.tableData.length == 0) {
                        this.$message.error('当前列表无数据，请调整搜索条件');
                        return false;
                    }
                    this.save_loading = true;
                    var saveData = [];
                    var role_rid = '';
                    this.tableData.forEach((item) => {
                        if (role_rid == '') {
                            role_rid = item.role_rid;
                        }
                        saveData.push({
                            row_rid: item.row_rid,
                            is_limit: item.is_limit ? 1 : 2
                        });
                    });

                    this.$api['roleRowsave']({
                        role_rid: role_rid,
                        data: saveData
                    })
                        .then((res) => {
                            this.save_loading = false;
                            if (res.code == 0) {
                                this.$message.success('保存成功');
                            }
                        })
                        .catch((error) => {
                            this.save_loading = false;
                        });
                })
                .catch(() => {});
        },
        reset() {
            this.initQueryParams();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
</style>